
import { defineComponent } from 'vue'
import ActiveUserMixin from '~/mixins/activeUserMixin'
import RepoDetailMixin from '~/mixins/repoDetailMixin'
import RepoListMixin from '~/mixins/repoListMixin'
import TomlGeneratorMixin from '~/mixins/tomlGeneratorMixin'

export default defineComponent({
  name: 'ActivateAnalysisModal',
  mixins: [RepoDetailMixin, TomlGeneratorMixin, ActiveUserMixin, RepoListMixin],
  data() {
    return {
      triggeringActivation: false
    }
  },
  computed: {
    toml(): string {
      return this.tomlTemplate(
        this.repository.config,
        this.repository.config['test_patterns'],
        this.repository.config['exclude_patterns']
      )
    },
    pullLabel(): string {
      return this.$route.params.provider === 'gl' ? 'merge' : 'pull'
    }
  },
  methods: {
    async refetchData(): Promise<void> {
      const { owner, provider } = this.$route.params
      await this.fetchActiveAnalysisRepoList({
        login: owner,
        provider,
        refetch: true
      })

      await this.fetchPendingAdHocRepoList({
        login: owner,
        provider,
        refetch: true
      })
    },
    async commitConfig(close: () => void, createPullRequest = false): Promise<void> {
      const args = {
        config: this.toml,
        repositoryId: this.repository.id,
        createPullRequest
      }

      try {
        const response = await this.commitConfigToVcs(args)
        await this.refetchData()
        await this.fetchBasicRepoDetails({ ...this.baseRouteParams, refetch: true })
        if (response.ok) {
          if (createPullRequest) {
            this.$toast.show({
              type: 'success',
              message: `We have created a ${this.pullLabel} request with the configuration. Analysis will start once it is commited.`,
              timeout: 5
            })
          } else {
            this.$toast.show({
              type: 'success',
              message: `Successfully activated ${this.repository.displayName}, the first run may take a while to finish.`,
              timeout: 5
            })
          }
          this.$root.$emit('repo-activation-triggered')
          close()
        } else {
          this.$toast.show({
            type: 'danger',
            message: 'Something went wrong while creating the configuration for this repository.',
            timeout: 10,
            primary: {
              label: 'Contact suppport',
              action: () => {
                this.$router.push('/support')
              }
            }
          })
        }
      } catch (e) {
        this.logErrorForUser(e as Error, 'Generate config', args)
        this.$toast.danger((e as Error).message.replace('GraphQL error: ', ''))
        this.fetchBasicRepoDetails({ ...this.baseRouteParams, refetch: true })
      }
    }
  },
  watch: {
    '$route.path': {
      handler(): void {
        this.$emit('close')
      }
    }
  }
})
